import { OTHER_REFERRAL_ID } from './constants';
import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@medely/ui-kit';
import { useMFAEnrollment } from '@mp/hooks';
import { AccountInfoFormValues } from './interface';

export const useAccountInfoStepMutation = () => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();
  const toast = useToast();
  const { redirectToMFAOnSignup } = useMFAEnrollment();

  const { mutateAsync: submitAccountInfo, isLoading: isSubmittingAccountInfo } = useMutation(
    (values: AccountInfoFormValues) =>
      axios.patch(`/v3/professional/application_wizard/next`, {
        professional: {
          nickname: values.nickname,
          account_attributes: {
            first_name: values.first_name,
            last_name: values.last_name,
            address_zip: values.address_zip,
            phone_number: values.phone_number,
          },
          referral_source_id: values.referral_source_id,
          other_referral_source:
            values.referral_source_id === OTHER_REFERRAL_ID
              ? values.other_referral_source
              : undefined,
        },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['currentUser']);
        queryClient.invalidateQueries(['GetCurrentUserForAccountInfoStep']);
        queryClient.invalidateQueries(['GetCurrentUserForMarketsStep']);
        redirectToMFAOnSignup();
      },
      onError: () => {
        toast.error('We had an issue, please try again.');
      },
    },
  );

  return { submitAccountInfo, isSubmittingAccountInfo };
};
